module.exports = __webpack_public_path__ + "img/bg3.4f6cc818.jpg";